import React from "react";

const DepositCard = ({deposit,billAmount}) => {
    const {balance, deposit_number, iban} = deposit;
    const formattedPrice = new Intl.NumberFormat('fa-IR');
    return <div className="deposit-card" style={{
        background: "#0f3f38"

    }}>
        <div className="deposit-box mb-5 ">
            <span>شماره حساب</span>
            <span className="number">{deposit_number}</span>
        </div>
        <div className="money-box text-sm">
            <span>موجودی</span>
            <span className="number">{formattedPrice.format(balance)} <small>ریال</small></span>
        </div>
        <div className="flex justify-between items-center text-sm">
            <span>وضعیت</span>
            <span>{balance-billAmount?.value>0 ? <span>موجودی کافی</span> :<span className="text-red-400">موجودی ناکافی</span>}</span>

        </div>
    </div>
}
export default DepositCard;